import styles from "./textArea.module.scss";
import {
  FieldValues,
  Path,
  PathValue,
  useController,
  UseControllerProps
} from "react-hook-form";
import { HTMLInputAutoCompleteAttribute } from "react";
import { Control } from "react-hook-form/dist/types";

type TextAreaProps<T extends FieldValues> = {
  disabled?: boolean;
  control: Control<T>
  error?: string;
  autoComplete?: HTMLInputAutoCompleteAttribute;
  maxLength?: number
} & UseControllerProps<T>

export const TextArea = <T extends FieldValues>({ disabled, name, control, error, autoComplete, maxLength }: TextAreaProps<T>) => {

  const {
    field: { ...inputControl },
  } = useController({
    name,
    control,
    defaultValue: "" as PathValue<T, Path<T>>
  });

  return (
    <div className={styles.container}>
      <textarea className={error ? styles.error : ""}
                autoComplete={autoComplete}
                maxLength={maxLength}
                {...inputControl}
                disabled={disabled}/>
      {error && <p className={styles.errorMessage}> {error}</p>}
    </div>
  )
}
